import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-search-deactivated',
  templateUrl: './search-deactivated.component.html',
  styleUrls: ['./search-deactivated.component.scss']
})
export class SearchDeactivatedComponent {
  @Input() public control: FormControl = new FormControl<boolean>(false);
  @Input() public label!: string;
  @Output() search = new EventEmitter<boolean>();

  constructor() {  
  }

  onChange() {
    this.search.emit(this.control.value);
  }
}
